<template>
  <base-page
    :title="`${$t('common.services.singular')} ${$t('common.details.plural')}`"
  >
    <template #main>
      <service-detail />
    </template>
  </base-page>
</template>
<script>
import BasePage from '@/views/BasePage.vue'
import ServiceDetail from '@/components/Service/ServiceDetail.vue'

export default {
  components: {
    BasePage,
    ServiceDetail
  }
}
</script>
